import type { components } from '../../generated/fct';
import { ApiError, ApiPaginatedResponse, ApiRequest } from '../shared';

type GeneratedReportFinding = components['schemas']['ReportFindingSchema-Output'];

export type ReportFindingConditionDetail = components['schemas']['ConditionDetailInput'] & {
  // TODO: Determine if we need to keep this
  displayName?: string;
  value: components['schemas']['ConditionDetailValue'];
};

export type ReportFinding = Omit<GeneratedReportFinding, 'conditionDetail'> &
  Required<Pick<GeneratedReportFinding, 'uuid'>> & {
    conditionDetail: ReportFindingConditionDetail[];
  };

export type ReportFindingStatus = components['schemas']['StatusEnum'];

export const REPORT_FINDING_STATUS = {
  DEPRECATED: 'deprecated',
  DRAFT: 'draft',
  PUBLISHED: 'published',
} as const satisfies Record<string, ReportFindingStatus>;

export type ReportFindingsByReportParams = {
  page: number;
  size: number;
  user_id: string;
};

export type ReportFindingsByReportRequestPayload = {
  params: Partial<ReportFindingsByReportParams>;
  uuid?: string;
};

export type ReportFindingsByReportRequest = ApiRequest<ReportFindingsByReportRequestPayload>;

export type ReportFindingsByReportResponse = ApiPaginatedResponse<ReportFinding>;

export type ReportFindingsByReportError = ApiError<unknown>;

export type CreateReportFindingPayload = {
  reportUuid: string;
} & Omit<ReportFinding, 'uuid'>;

export type CreateReportFindingRequest = ApiRequest<CreateReportFindingPayload>;

export type CreateReportFindingResponse = ReportFinding;

export type CreateReportFindingError = ApiError<unknown>;

export interface PatchReportFinding extends ReportFinding {
  // TODO: Determine if we need to keep this
  medicalHistory?: components['schemas']['CompleteMedicalHistory'] | null;
}

export type PatchReportFindingPayload = Partial<PatchReportFinding> &
  Required<Pick<PatchReportFinding, 'uuid'>> & {
    reportUuid: string;
  };

export type PatchReportFindingRequest = ApiRequest<PatchReportFindingPayload>;

export type PatchReportFindingResponse = ReportFinding;

export type PatchReportFindingError = ApiError<unknown>;
